"use client";
import { useQuery } from "@tanstack/react-query";
import styles from "../Footer.module.css";
import React from "react";
import { useGlobal } from "@/features/global/GlobalContext";
import { rpc } from "#rpc";
import { getMedia } from "@frend-digital/storyblok";
import type { StoryblokAsset } from "@/storyblok-base";
import type { AssetStoryblokCompat } from "@/types/storyblok-compat";

export type MatchedPaymendMethod = {
	icon?: StoryblokAsset;
	type?: string;
};

export const FooterPaymentMethods = () => {
	const { data: globalConfig } = useGlobal();
	const { data: paymentMethods } = useQuery({
		queryKey: ["payment-methods"],
		queryFn: async (): Promise<MatchedPaymendMethod[]> => {
			const paymentMethods = await rpc.checkout.paymentMethods();

			const paymentIcons = globalConfig?.paymentMethods;

			const uniquePaymentMethods = new Map();

			for (const method of paymentMethods) {
				for (const icon of paymentIcons ?? []) {
					const typeMatch = icon.type === method.type;
					const brandMatch = method.brands?.some((brand) => brand === icon.type);

					if (typeMatch || brandMatch) {
						const key = brandMatch ? icon.type : method.type;

						if (!uniquePaymentMethods.has(key)) {
							uniquePaymentMethods.set(key, {
								type: key,
								icon: icon.icon,
							});
						}
					}
				}
			}

			return paymentIcons
				? Array.from(uniquePaymentMethods.values()).sort((a, b) => {
						const aIndex = paymentIcons.findIndex((icon) => icon.type === a.type);
						const bIndex = paymentIcons.findIndex((icon) => icon.type === b.type);
						return aIndex - bIndex;
					})
				: [];
		},
	});

	return (
		<span className={styles.payment}>
			{paymentMethods
				?.filter(({ icon }) => icon)
				.map(({ icon }) => {
					const media = getMedia(icon! as AssetStoryblokCompat);
					return (
						<div className={styles.paymentOption} key={icon?.id}>
							<img
								src={media?.url}
								alt={media?.alt!}
								loading="lazy"
								fetchPriority="low"
								style={{ objectFit: "contain", width: "100%", height: "100%" }}
							/>
						</div>
					);
				})}
		</span>
	);
};
